<!-- 图像练习三合一：识图练习、走图练习、识图学习 -->
<template>
    <div class="student-page m-imageTabs">
        <el-tabs v-model="tabs" type="border-card">
            <el-tab-pane :label="$t('stu.imgStudyMenu')" name="imgStudy">
                <img-study v-if="tabs==='imgStudy'"></img-study>
            </el-tab-pane>
            <el-tab-pane :label="$t('stu.imgPracticeMenu')" name="imgPractice">
                <img-practice v-if="tabs==='imgPractice'"></img-practice>
            </el-tab-pane>
            <el-tab-pane :label="$t('stu.trackPracticeMenu')" name="trackPractice">
                <track-practice v-if="tabs==='trackPractice'"></track-practice>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import ImgStudy from './ImgStudy'
    import ImgPractice from './ImgPractice'
    import TrackPractice from './TrackPractice'

    export default {
        components: {
            ImgStudy,
            ImgPractice,
            TrackPractice
        },
        data() {
            return {
                tabs: 'imgStudy',
            }
        },
        created() {

        },
        computed: {},
        methods: {},
        watch: {},
    }
</script>

<style scoped lang="scss">
    @import '../../../style/const';

    .student-page {
        padding-top: 40px;
        padding-bottom: 40px;
    }
</style>

<style lang="scss">
    .m-imageTabs {
        height: 100%;

        > .el-tabs {
            display: flex;
            flex-direction: column;
            height: 100%;
            .el-tabs__content {
                flex: 1;
                overflow: auto;
            }
            .el-tab-pane {
                display: flex;
                flex-direction: column;
                height: 100%;
            }
        }


        .student-page {
            margin-top: 40px!important;
        }
    }

    /* 针对 1680 以及 125% 的 1920 */
    @media screen and (min-width: 1440px) and (max-width: 1680px) {
        .m-imageTabs .student-page {
            padding-top: 0 !important;
            margin-top: 2vh!important;
            width: 90%;
            min-width: inherit;

            .btn-group {
                margin-top: 5vh;
            }
        }
    }

    /* 1440 及 1367 */
    @media screen and (max-width: 1440px) {
        .term-title {
            line-height: 46px!important;
        }
        .term-content.content-radio {
            padding-top: 5px!important;
            padding-bottom: 5px!important;
        }
        #pane-imgPractice .btn-group {
            margin-top: 15px;
        }
        .m-imageTabs .student-page {
            padding-top: 0 !important;
            margin-top: 10px!important;
            width: 100%;
            min-width: inherit;

            .btn-group {
                margin-top: 30px;
            }
        }
    }
</style>
